// extracted by mini-css-extract-plugin
module.exports = {"question":"QuizQuestion_question__j53YR"};